/*
  NV — per-colour media filtering support.

  The filtering itself is pure CSS (see the <style> block emitted by
  snippets/product-media-gallery.liquid). This file exists only to keep Dawn's
  gallery slider honest afterwards: SliderComponent measures its pages once at
  construction, so when a colour change hides or reorders slides the "1 / 6"
  counter and the prev/next paging would otherwise go stale.

  Deferred, ~1KB, no first-paint cost. If it never runs, images still filter
  correctly — only the counter lags.
*/
(function () {
  // The Liquid snippet stamps the colour option's name onto this script tag,
  // e.g. <script src="nv-pdp-media.js" data-nv-color-name="Color" defer>.
  function colorNames() {
    var names = {};
    document.querySelectorAll('script[data-nv-color-name]').forEach(function (el) {
      var name = el.getAttribute('data-nv-color-name');
      if (name) names[name] = true;
    });
    return names;
  }

  function refresh() {
    document.querySelectorAll('slider-component').forEach(function (component) {
      if (typeof component.resetPages !== 'function') return;
      component.resetPages();
      if (component.slider && component.slider.scrollLeft !== 0) {
        component.slider.scrollTo({ left: 0, behavior: 'auto' });
      }
    });
  }

  function init() {
    var names = colorNames();
    if (Object.keys(names).length === 0) return;

    document.addEventListener('change', function (event) {
      var target = event.target;
      if (!target || target.type !== 'radio' || !names[target.name]) return;
      // Wait for the browser to apply the new :has() rules before re-measuring.
      requestAnimationFrame(function () {
        requestAnimationFrame(refresh);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
